import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import Button from 'widgets/Button';
import { convertSecondsToHMS, getRemainingTimeLabel } from 'libs/common';
import { SESSION_TIMEOUT } from 'libs/constants';
import { MOBILE_VIEW } from 'libs/windowDimension';
import { handleLogoutUser } from 'redux/actions/auth';
import Modal from 'components/Modal';
import colors from 'assets/styles/jsVariables/colors';
import './IdleModal.scss';

const styles = {
  modalButtonStyle: {
    '&:hover': {
      background: colors.hoverColor,
      boxShadow: 'rgba(176, 176, 176, 0.5) 0px 2px 5px 1px'
    },
    boxShadow: 'rgba(176, 176, 176, 0.5) 0px 2px 5px 1px'
  },
  modalButtonLabelStyle: {
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '20px',
    textTransform: 'capitalize',
  }
};

const intlLabels = {
  hours: 'components.idleModal.modal.highLightText.hoursLabel',
  hour: 'components.idleModal.modal.highLightText.hourLabel',
  minutes: 'components.idleModal.modal.highLightText.minutesLabel',
  minute: 'components.idleModal.modal.highLightText.minuteLabel',
  seconds: 'components.idleModal.modal.highLightText.secondsLabel',
  second: 'components.idleModal.modal.highLightText.secondLabel'
};

class IdleModal extends Component {
  constructor() {
    super();
    this.state = {
      remainingSeconds: 0
    };
    this.timerID = null;
  }

  componentWillReceiveProps({ open: nextOpen }) {
    const { open } = this.props;

    if (!open && nextOpen) {
      this.startTimer();
      this.initializeRemainingSeconds();
    }
  }

  shouldComponentUpdate({ open: nextOpen }) {
    return this.props.open || nextOpen;
  }

  componentDidUpdate({ open }, { remainingSeconds: nextRemainingSeconds }) {
    if (this.props.open && open && nextRemainingSeconds <= 0) {
      this.handleLogout({ snackNotification: true });
    }
  }

  startTimer = () => {
    this.timerID = setInterval(
      () => this.setState({ remainingSeconds: this.state.remainingSeconds - 1 }),
      1000
    );
  }

  clearTimer = () => {
    clearInterval(this.timerID);
    this.timerID = null;
  }

  initializeRemainingSeconds = () => {
    this.setState({ remainingSeconds: 300 });
  }

  handleContinue = () => {
    const { toggleModal } = this.props;
    this.clearTimer();
    toggleModal();
  }

  handleLogout = ({ snackNotification = true }) => {
    const { toggleModal, logoutUser } = this.props;
    this.clearTimer();
    toggleModal();
    logoutUser(
      {
        notificationMsg: snackNotification
          ? <FormattedMessage id={SESSION_TIMEOUT.notificationMsg} />
          : false
      }
    );
  }

  render() {
    const { open, windowDimension, intl } = this.props;
    const intlConfig = { intl, labels: intlLabels };
    const { remainingSeconds } = this.state;
    const { hour, min, sec } = convertSecondsToHMS(remainingSeconds);
    const timeLabel = getRemainingTimeLabel(hour, min, sec, intlConfig);
    return (
      <Modal
        title={intl.formatMessage({ id: 'components.idleModal.modal.title' })}
        open={open}
        toggleModal={this.handleContinue}
        paperStyle={{ borderRadius: '10px' }}
        titleContainerStyle={{ paddingLeft: 20, paddingRight: 20 }}
        childrenStyle={{ overflowY: 'auto', paddingLeft: 20, paddingRight: 20 }}
        containerStyle={{ zIndex: 999999999 }}
        actions={[
          <Button
            type="raised"
            color="primary"
            key="Continue"
            cssStyles={{
              root: styles.modalButtonStyle,
              label: styles.modalButtonLabelStyle
            }}
            onClick={this.handleContinue}
            style={{ borderRadius: 10, marginBottom: 20, marginRight: 10 }}
          >
            {MOBILE_VIEW(windowDimension)
              ? intl.formatMessage({ id: 'components.idleModal.modal.continue.buttonLabelMobile' })
              : intl.formatMessage({ id: 'components.idleModal.modal.continue.buttonLabelDesktop' })}
          </Button>,
          <Button
            type="raised"
            color="primary"
            key="Sign_Out"
            cssStyles={{
              root: styles.modalButtonStyle,
              label: styles.modalButtonLabelStyle
            }}
            onClick={() => this.handleLogout({ snackNotification: false })}
            style={{ borderRadius: 10, marginBottom: 20, marginRight: 17 }}
          >
            {intl.formatMessage({ id: 'components.idleModal.modal.signOut.buttonLabel' })}
          </Button>
        ]}
      >
        <div>
          <div className="IdleModal__ContentText">
            <FormattedMessage id="components.idleModal.modal.contentText" />
          </div>
          <br />
          <div className="IdleModal__HighlightText">
            <FormattedMessage id="components.idleModal.modal.highLightText" values={{ timeLabel }} />
          </div>
        </div>
      </Modal>
    );
  }
}

IdleModal.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  logoutUser: PropTypes.func.isRequired,
  windowDimension: PropTypes.any.isRequired,
  intl: PropTypes.object.isRequired
};

export default connect(
  ({ windowDimension }) => ({ windowDimension }),
  { logoutUser: handleLogoutUser }
)(injectIntl(IdleModal));



// WEBPACK FOOTER //
// ./src/components/IdleModal/IdleModal.jsx